import { BaseService, RequestType, ResponseType } from "@intech/react-service";
import { HeaderInfoRendEntidade } from "../entidades";

class InfoRend extends BaseService {
  constructor() {
    super("infoRend");
  }

  BuscarReferencias = () =>
    this.CreateRequest<Array<number>>(RequestType.GET, `BuscarReferencias`);

  BuscarPorReferencia = (referencia: number) =>
    this.CreateRequest<HeaderInfoRendEntidade>(RequestType.GET, `BuscarPorReferencia/${referencia}`);

  Relatorio = (referencia: number, enviarPorEmail = false) =>
    this.CreateRequest<any>(RequestType.GET, `GerarRelatorio/${referencia}/${enviarPorEmail}`, null, ResponseType.Blob);

}

export const InfoRendService = new InfoRend();
